import { E164Number } from "../../../api/src/types";
import { isValidPhoneNumber } from "react-phone-number-input";

export const validatePhoneNumber = (value: E164Number) => {
  if (value.length === 0) {
    return null;
  }
  if (!isValidPhoneNumber(value)) {
    return "Invalid phone number";
  }
  return null;
};

// Handle currency input changes
export const validateCurrency = (value: string): string | null => {
  if (value === "") {
    return null;
  }

  // Check for invalid patterns before sanitizing
  // Multiple hyphens are invalid
  if ((value.match(/-/g) ?? []).length > 1) {
    return "Currency cannot have multiple negative signs (-)";
  }

  // Multiple decimal points are invalid
  if ((value.match(/\./g) ?? []).length > 1) {
    return "Currency can only have one decimal point";
  }

  // Remove currency symbols and commas for validation
  const numericValue = value.replace(/[^0-9.-]+/g, "");

  // Ensure there's a valid number structure (not just hyphens and dots)
  if (!/^-?\d*\.?\d*$/.test(numericValue)) {
    return "Please enter a valid currency amount";
  }

  // Check if it's a valid number
  if (isNaN(parseFloat(numericValue))) {
    return "Please enter a valid currency amount";
  }

  // Check for too many decimal places
  const parts = numericValue.split(".");
  if (parts.length > 1 && parts[1] && parts[1].length > 2) {
    return "Currency can only have up to 2 decimal places";
  }

  return null;
};
